import { isType } from '@mtna/core-ts';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsTextFilter } from '../../../text-filter/text-filter.model';
import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByText<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public textFilters: Array<RdsTextFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByText(something: unknown): something is FilterByText<Variable | VariableSummary> {
  return isType<FilterByText<Variable | VariableSummary>>(something, 'variable', 'textFilters');
}
